import { render, staticRenderFns } from "./Mouvements.vue?vue&type=template&id=27ba3cd0&"
import script from "./Mouvements.vue?vue&type=script&lang=js&"
export * from "./Mouvements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports